import * as React from 'react';

import { Search } from '@mint-lib/icons';
import { cn } from '@mint-lib/tw-utils';
import { Command as CommandPrimitive } from 'cmdk';

import { typographyVariants } from './typography.jsx';

function Command({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive>) {
  return (
    <CommandPrimitive
      data-slot="command"
      className={cn(
        'flex h-full w-full flex-col overflow-hidden rounded-sm',
        className,
      )}
      {...props}
    />
  );
}

function CommandInput({
  className,
  select = false,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Input> & {
  select?: boolean;
}) {
  return (
    <div
      data-slot="command-input-wrapper"
      className={cn(
        'flex h-8 items-center gap-2 border-border-primary px-3',
        select ? 'border-b' : 'rounded-md border',
        className,
      )}
    >
      <Search className="fill-icon-secondary" />
      <CommandPrimitive.Input
        data-slot="command-input"
        className={cn(
          'placeholder:text-muted-foreground flex h-10 w-full bg-transparent py-3 text-sm outline-hidden disabled:opacity-50',
        )}
        {...props}
      />
    </div>
  );
}

function CommandList({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.List>) {
  return (
    <CommandPrimitive.List
      data-slot="command-list"
      className={cn(
        'max-h-75 scroll-py-1 overflow-x-hidden overflow-y-auto',
        className,
      )}
      {...props}
    />
  );
}

function CommandEmpty({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Empty>) {
  return (
    <CommandPrimitive.Empty
      data-slot="command-empty"
      className={cn(
        typographyVariants({
          variant: 'bodyShort01',
          className: 'secondary',
        }),
        'peer flex justify-center p-4',
        className,
      )}
      {...props}
    />
  );
}

function CommandGroup({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Group>) {
  return (
    <CommandPrimitive.Group
      data-slot="command-group"
      className={className}
      {...props}
    />
  );
}

function CommandSeparator({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Separator>) {
  return (
    <CommandPrimitive.Separator
      data-slot="command-separator"
      className={className}
      {...props}
    />
  );
}

function CommandItem({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Item>) {
  return (
    <CommandPrimitive.Item
      data-slot="command-item"
      className={className}
      {...props}
    />
  );
}

function CommandFooter({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="command-footer"
      className={cn(
        'flex h-10 items-center rounded-b-[3px] border border-border-secondary bg-background-default p-2',
        className,
      )}
      {...props}
    />
  );
}

export {
  Command,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandSeparator,
  CommandFooter,
};
